import React from 'react';

// T-018 hardening: one bad data row must never blank the whole module.
// App.jsx wraps every screen mount in this boundary, so a render throw
// degrades to a card-level error while the acting-as banner and navs stay
// alive. Keyed by screen id at the call sites so navigating to another
// screen resets the boundary automatically.
//
// Inline styles (not classes) for the same reason as App's StatusScreen:
// renders identically regardless of the prefixed bundle CSS. Palette
// matches StatusScreen's error tone.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[Investment] screen crashed:', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: 24, margin: 24,
          border: '1px solid #fecaca',
          borderRadius: 12,
          background: '#fef2f2',
          color: '#9f1239',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          maxWidth: 640,
        }}>
          <strong>This screen hit an error.</strong>
          <p style={{ margin: '8px 0 0' }}>
            The rest of the app still works — use the navigation to switch
            screens. Please tell Kareem what you were doing when this appeared.
          </p>
          <p style={{ fontFamily: 'monospace', fontSize: 12, margin: '8px 0 0', whiteSpace: 'pre-wrap' }}>
            {String(this.state.error?.message || this.state.error)}
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
